import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { DataKeys } from './types'

interface Scheme {
    id: DataKeys
}

export const DataForm: {
    input: InputBuildProps & Scheme
    layout: LayoutProps
}[] = [
    {
        input: {
            id: 'razaoSocial',
            label: 'Razão Social',
            required: true,
            maxLength: 64
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 8 }
        }
    },
    {
        input: {
            id: 'cnpj',
            label: 'CNPJ',
            required: true,
            maskReplace: 'cnpj',
            inputMode: 'numeric'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    },
    {
        input: {
            id: 'email',
            label: 'E-mail',
            maxLength: 128,
            required: true,
            inputMode: 'email',
            type: 'email'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 8 }
        }
    },
    {
        input: {
            id: 'contato',
            label: 'Telefone',
            required: true,
            inputMode: 'tel',
            maskReplace: 'contato'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    },
    {
        input: {
            id: 'IE',
            label: 'Inscrição Estadual',
            maxLength: 20
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'IM',
            label: 'Inscrição Municipal',
            maxLength: 20
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    }
]
